<template>
  <div class="login-page">
    <div class="login-box">
      <div class="card card-outline card-primary">
        <div class="card-header text-center">
          <a href="#" class="h2">
            <img src="@/assets/vnpt-logo.png" alt="" class="brand-image img-circle elevation-3" style="opacity: .8; margin-top: -.5rem; margin-right: .2rem;height: 33px;">&nbsp;<b>{{ $t('labels.signIn') }}</b>
          </a>

        </div>
        <div class="card-body">
          <p class="login-box-msg text-danger" v-if="errors.message">{{ $t('labels.noticeLogin') }}</p>
          <form @submit.prevent="onSubmit()">
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="fas fa-user"></i></span>
              </div>
              <input type="text" class="form-control" :placeholder="$t('labels.userName')" v-model="model.username"
                @blur="validate_user()" v-bind:class="{ 'is-invalid': errors.username }" />
            </div>
            <div class="text-danger mb-2" v-if="errors.username">{{ $t('labels.noticeUserName') }}</div>

            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="fas fa-lock"></i>
                </span>
              </div>
              <input v-if="showPassword" type="text" class="form-control" v-model="model.password"
                @blur="validate_pass()" v-bind:class="{ 'is-invalid': errors.password }"
                :placeholder="$t('labels.password')" />
              <input v-else type="password" class="form-control" v-model="model.password" @blur="validate_pass()"
                v-bind:class="{ 'is-invalid': errors.password }" :placeholder="$t('labels.password')" />
              <div class="input-group-append" @click="toggleShow">
                  <span class="input-group-text" v-if="!showPassword"><i class="fa fa-eye"></i></span>
                  <span class="input-group-text" v-else><i class="fa fa-eye-slash"></i></span>
              </div>
            </div>
            <div class="text-danger mb-2" v-if="errors.password">{{ $t('labels.noticePasword') }}</div>


            <div class="row">
              <div class="col-12">
                <button type="submit" :disabled="submitted" class="btn btn-primary btn-block">
                  <span v-if="submitted" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{
                  $t('labels.signIn')
                }}</button>
              </div>
              <!-- /.col -->
            </div>
          </form>
          <!-- /.social-auth-links -->

          <!-- <p class="mb-1 mt-3 text-center">
            <a href="#">{{ $t('labels.forgotPassword') }}</a>

          </p>
          <p class="mb-0 text-center">
            <a href="#" class="text-center">{{ $t('labels.registerMembership') }}</a>
          </p>
          <p class="mt-0 mb-0 text-muted text-right">

          </p> -->
        </div>

        <p class="mt-1 mb-3 text-muted text-center">
          <strong>
            <a href="#">
              <img src="../../assets/vnpt-logo.png" width="30" height="30" alt="Logo"
                class="brand-image img-circle elevation-3" style="opacity: .8"> TTCNTT - VNPT ĐỒNG THÁP
            </a>
            <!-- <TheLocalChangeVue /> -->
          </strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// import TheLocalChangeVue from '@/components/shared/TheLocalChange.vue'
import { mapActions } from 'vuex'
//import {useToast} from 'vue-toastification';
export default {

  name: "TheLogin",
  components: {
    // TheLocalChangeVue
  },
  data() {
    return {
      isLoading: false,
      showPassword: false,
      result: false,
      errors: {
        message: '',
        username: '',
        password: ''
      },
      model: {
        username: '',
        password: ''
      },
      show: true,
      submitted: false,
      //toast: useToast()
    };
  },
  computed: {
  },
  created() {
    // call function logout
    //this.toast.errors('xx');
    localStorage.removeItem('reloaded');
    this.onLogout()

  },
  methods: {
    ...mapActions('authentication', ['login', 'logout']),
    async onSubmit() {
      this.submitted = true;
      if (this.validate()) {
        let username = this.model.username
        let password = this.model.password
        //this.$router.go('/404')
        await this.login({ username, password })
      }
      this.submitted = false;
    },
    onLogout() {
      this.logout()
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.model.username = "";
      this.model.password = "";
    },
    validate() {
      let isvalid = true
      // set up errors
      this.errors = {
        username: '',
        password: ''
      }
      // check null model
      if (!this.model.username) {
        this.errors.username = 'Vui lòng nhập tài khoản'
        //
        isvalid = false
      }
      if (!this.model.password) {
        this.errors.password = 'Vui lòng nhập mật khẩu'
        isvalid = false
      }
      return isvalid
    },
    validate_user() {
      let isvalid = true
      // set up errors
      this.errors = {
        username: ''
      }
      // check null model
      if (!this.model.username) {
        this.errors.username = 'Vui lòng nhập tài khoản'
        //
        isvalid = false
      }
      return isvalid
    },
    validate_pass() {
      let isvalid = true
      // set up errors
      this.errors = {
        password: ''
      }
      // check null model
      if (!this.model.password) {
        this.errors.password = 'Vui lòng nhập mật khẩu'
        //
        isvalid = false
      }
      return isvalid
    }
    ,
    toggleShow() {
      this.showPassword = !this.showPassword;
    }
  }
}
</script>